var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "containerDiv" } },
    [
      _c("TagModal", {
        attrs: {
          show: _vm.showModal,
          selectedAction: _vm.selectedAction,
          loadData: _vm.currentRow,
          tipocc: _vm.tipocc
        },
        on: { closeModal: _vm.handleCloseModal }
      }),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.handleDeleteVal,
          titulo: "Eliminación Tag",
          mensaje: _vm.$t(_vm.deleteMessage),
          textoBtnSi: _vm.$t("mensajes.mensajesInformes.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesInformes.btnCancelarGeneracion")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.deleteReg($event)
          }
        }
      }),
      _c("div", { attrs: { id: "headerDiv" } }, [
        _c(
          "div",
          { staticClass: "section" },
          [
            _c("v-text-field", {
              staticStyle: { "margin-left": "1%", height: "max-content" },
              attrs: { clearable: "", label: "Buscar..." },
              on: { input: _vm.searchData },
              model: {
                value: _vm.searchInput,
                callback: function($$v) {
                  _vm.searchInput = $$v
                },
                expression: "searchInput"
              }
            })
          ],
          1
        ),
        _c("div", { staticClass: "section" }),
        _c(
          "div",
          {
            staticClass: "section",
            staticStyle: { "justify-content": "flex-end" }
          },
          [
            _c(
              "v-btn",
              {
                staticStyle: { height: "48px" },
                attrs: { color: "#ffe800" },
                on: { click: _vm.handleCreate }
              },
              [
                _c(
                  "v-icon",
                  {
                    staticStyle: {
                      "font-size": "160%",
                      "margin-right": "7% !important"
                    },
                    attrs: { dark: "", left: "" }
                  },
                  [_vm._v("add_circle_outline")]
                ),
                _c("span", { staticStyle: { "font-size": "1.5vmin" } }, [
                  _vm._v("Crear ")
                ])
              ],
              1
            )
          ],
          1
        )
      ]),
      _c(
        "div",
        { attrs: { id: "bodyDiv" } },
        [
          _c(
            "v-card",
            { staticStyle: { width: "100%" } },
            [
              _c("GridComponent", {
                ref: "gridComponent",
                staticClass: "ag-theme-material",
                attrs: { id: "gridComponent", gridOptions: _vm.gridOptions }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }